import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const snackbar: any;

@Component({
  selector: 'app-transport-manager-update-password',
  templateUrl: './transport-manager-update-password.component.html',
  styleUrls: ['./transport-manager-update-password.component.css']
})
export class TransportManagerUpdatePasswordComponent implements OnInit {

  mailId = 'mailId@groupten.com';
  password: any;
  confrimpassword: any;
  inputConfirmType: string = 'password';
  inputNewType: string = 'password';
  token: any;
  isPasswordNotMatch: boolean;

  passwordSuccess:boolean = false;

  public pathUrl;
  public param;
  public userType;

  constructor(
    private router: Router, 
    public storage: StorageService,
    public swal: SweetAlert, 
    public api: ApiService,) { }

  ngOnInit(): void {
    this.token = this.storage.get('token');
    this.pathUrl = this.router.url;
    this.configUser();
  }

  configUser(){
    let result = this.pathUrl.split('=');
    this.param = result[1];
    this.userType = this.pathUrl.split('$#$')[1]
  }

  submit(): void {
    this.checkPin();
    console.log(this.confrimpassword && this.password);
    if (this.confrimpassword && this.password && !this.isPasswordNotMatch) {
      const obj = {
        //activationKey: this.token,
        newPassword: this.password,
        confirmPassword: this.confrimpassword,
        param:this.pathUrl.split('key=')[1],
      };
      // let type = 
      let apiMethod = '';
      if(this.userType =='o'){
        apiMethod = "orgCreatePassword";
      }
      else if(this.userType == 'e'){
        apiMethod = 'empCreatePassword';
      }
      else if(this.userType == 'v'){
        apiMethod = 'vendorCreatePassword';
      }
      this.api[apiMethod](obj) //updatepassword(obj)
        .then((res: any) => {
          if (res.status == 'success') {
            this.swal.swalFunction(res.status, res.status, res.message, 2000);
            setTimeout(()=>{
              if(this.userType == 'o'){
                this.router.navigate(['organization/transport-manager/login']);
              }
              else if(this.userType == 'e'){
                this.passwordSuccess = true;
              }
              else if(this.userType == 'v'){
                this.router.navigate(['organization/vendor/login']);
              }
            },2500)
          }else {
            this.swal.swalFunction('error', res.status, res.message, 2000);
          }
          console.log(res);
        }).catch((err) => {
          console.log(err);
        });
      // snackbar(`<span class="text-warning"> Password success </span>`);
    } else {
      snackbar(`<span class="text-warning"> Password and confrim password required </span>`);
    }
  }
  viewConfirmPassword() {
    this.inputConfirmType = this.inputConfirmType == 'text' ? 'password' : 'text';
  }
  viewNewPassword() {
    this.inputNewType = this.inputNewType == 'text' ? 'password' : 'text';
  }
  checkPin() {
    if (this.password !== this.confrimpassword) {
      this.isPasswordNotMatch = true;
    } else {
      this.isPasswordNotMatch = false;
    }
  }
}
